import {create} from 'zustand';

interface BottomModalState {
    isOpen: boolean;
    content: React.ReactNode;
    open: (content: React.ReactNode) => void;
    close: () => void;
    title?: string;
    setTitle?: (title: string) => void;
    heightAuto?: boolean;
    setHeightAuto?: (heightAuto: boolean) => void;
    radius?: number;
    setRadius?: (radius: number | undefined) => void;
    onConfirm?: () => void;
    setOnConfirm?: (onConfirm: () => void) => void;
}

export const useBottomModalStore = create<BottomModalState>(set => ({
    isOpen: false,
    content: null,
    open: content => set({isOpen: true, content}),
    close: () =>
        set({isOpen: false, content: null, title: '', heightAuto: false, radius: undefined, onConfirm: () => {}}),
    title: '',
    setTitle: title => set({title}),
    heightAuto: false,
    setHeightAuto: heightAuto => set({heightAuto}),
    radius: undefined,
    setRadius: radius => set({radius}),
    onConfirm: () => {},
    setOnConfirm: onConfirm => set({onConfirm}),
}));
